import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

export const DOC = gql`
  ${fragments.serviceCenter.DOC}
  mutation CreateServiceCenter(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $input: ServiceCenterInput!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                createServiceCenter(input: $input) {
                  ...FragmentServiceCenter
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.CreateServiceCenterMutation,
    ents.extra.space.ServiceCenter,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'space',
              graphql.transformers.OUT.select(
                'createServiceCenter',
                fragments.serviceCenter.TRANSFORMER,
              ),
            ),
          ),
        ),
      ),
    ),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.CreateServiceCenterMutation,
  ents.extra.space.ServiceCenter,
  graphql.schema.CreateServiceCenterMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
